export default __webpack_public_path__ + "static/media/stuck-veskovic-modernes-badezimmer-6.8f000239.jpg";